import React, { useState, useEffect } from "react";
import eventBus from '../../../../../../util/eventBus'
import "./filt.less"
import { DatePicker, Button, Icon, Input, Select, Switch, Tooltip, Tag, Modal } from '@kdcloudjs/kdesign'
import { inputStyle, selectionStyle, selectTagStyle } from "./utils/style"
import { chartdir } from "./utils/config"

// schemeStatus: 1,//1：默认（关闭） 2：查看 3：新增
// NScheme

const normalScheme = { id: "NScheme", schemeName: "常用条件过滤", default: false }

function APP(props) {
    console.log("===filt App===", props);

    const {
        model,
        searchLoading,
        filtItems,
        // showScheme: _showScheme,
        showScheme,
        schemes,
        maxLevel,
        updateState,
        myInvoke,
        getFullParams,
        preShowScheme
    } = props

    const { invoke } = model

    // 方案状态
    const [schemeStatus, setSchemeStatus] = useState(() => showScheme.id === "NScheme" ? 1 : 2)

    // 方案输入框
    const [showSchemeName, setShowSchemeName] = useState(showScheme?.schemeName ?? "")

    // 过滤面板
    const [showFilt, setShowFilt] = useState((showScheme?.id ?? null) === "NScheme")

    // 方案下拉框（受控）
    const [showSchemeBoard, setShowSchemeBoard] = useState(false)

    // 元方案
    const [mateScheme, setMateScheme] = useState(true)

    // 选择/切换方案
    function handleSchmes(value, option) {
        const _showScheme = option.item
        // 如果是方案新增状态
        if (schemeStatus === 3) {
            Modal.confirm({
                title: "操作确认",
                body: (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <img src="data:image/png;base64,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" />
                        <p style={{ marginTop: "15px" }}>检测到您有新增方案，是否不保存直接切换？</p>
                        <p>若不保存，将丢失这些更改。</p>
                    </div>
                ),
                cancelText: "仍要切换",
                okText: "立即保存",
                onCancel: () => {
                    handleSchmesSure(_showScheme)
                },
                onOk: () => {
                    addScheme()
                }
            })
        } else {
            handleSchmesSure(_showScheme)
        }
    }

    // 
    const handleSchmesSure = (_showScheme) => {
        console.log("handleSchmesSure", _showScheme);

        updateState("preShowScheme", showScheme)

        setMateScheme(true)

        if (_showScheme.id === "NScheme") {
            updateState("showScheme", _showScheme)
            // 查询
            submitFiltForm()
        } else {
            useSelectedScheme(_showScheme.id)
        }
    }

    // 使用选择的方案
    const useSelectedScheme = schemeId => {
        invoke("schemeQueryOrgChart", { schemeId })
    }

    // 打开新增方案
    const handleAddScheme = () => {

        setShowFilt(true)

        updateState("preShowScheme", showScheme)

        updateState("showScheme", null)
    }

    // 删除方案
    const delScheme = () => {

        myInvoke("deleteScheme", { schemeId: showScheme?.id ?? null }, "deleteScheme")
            .then(data => {

                const _schemes = data?.schemes ?? []

                updateState("schemes", [normalScheme, ..._schemes])

                updateState("showScheme", normalScheme)

                setShowSchemeName("")

                setMateScheme(true)

                submitFiltForm()
            })
    }

    // 保存方案
    const addScheme = () => {
        const _newScheme = {
            schemeId: showScheme?.id ?? null,
            schemeName: showSchemeName,
            scheme: getFullParams()
        }

        myInvoke("saveOrUpdateScheme", _newScheme, "saveOrUpdateScheme")
            .then(data => {
                const _showScheme = data?.showScheme?.showScheme ?? null

                const _schemes = data?.schemes ?? []

                // 新的方案以及方案列表
                updateSchemeInfo(_schemes, _showScheme)

                setSchemeStatus(2)

                setMateScheme(true)

                useSelectedScheme(_showScheme.id)
            })
    }

    const updateSchemeInfo = (_schemes, _showScheme) => {
        console.log("_schemes", _schemes);
        console.log("_showScheme", _showScheme);

        updateState("schemes", [normalScheme, ..._schemes])

        updateState("showScheme", _showScheme)

        setShowSchemeName(_showScheme?.schemeName ?? "")
    }

    // 变更默认方案
    const setDefaultScheme = flag => {
        if (!showScheme) return

        const params = {
            schemeId: showScheme?.id ?? null,
            isDefault: flag
        }

        myInvoke("setDefaultScheme", params, "setDefaultScheme")
            .then(data => {
                const _showScheme = data?.showScheme ?? null

                const _schemes = data?.schemes ?? []

                updateSchemeInfo(_schemes, _showScheme)
            })
    }

    const opScheme = (params) => {
        switch (params.value) {
            // 取消默认
            case "0":
                setDefaultScheme(false)
                break;
            // 设为默认
            case "1":
                setDefaultScheme(true)
                break;
            // 删除
            case "2":
                delScheme()
                break;
            // 取消
            case "3":
                setSchemeStatus(2)

                updateState("showScheme", preShowScheme)
                break;

        }
    }

    // 查询
    const submitFiltForm = () => {
        updateState("searchLoading", true)
        invoke("searchChartData", getFullParams())

        setMateScheme(true)
    }

    // 查询岗位
    const makeOpenPositionF7 = () => {
        myInvoke("openPositionF7", {
            queryDate: filtItems.queryDate,
            orgs: filtItems.orgs.map(item => item.id)
        }, "openPositionF7")
            .then(data => {
                if (!data) return
                updateState("filtItems", {
                    ...filtItems,
                    station: data?.positionInfo ?? null
                })

                setMateScheme(false)
            })
    }

    // 结构图样式
    const makeOpenOrgChartStyleF7 = () => {
        myInvoke("openOrgChartStyleF7", {}, "openOrgChartStyleF7")
            .then(data => {
                if (!data) return

                updateState("filtItems", {
                    ...filtItems,
                    chartStyle: data?.data ?? null
                })

                setMateScheme(false)
            })
    }

    // 主管责任单位
    const makeOpenOrgF7 = () => {
        myInvoke("openOrgF7", {
            queryDate: filtItems?.queryDate ?? new Date(),
            positionId: filtItems?.station?.id ?? null
        }, "openOrgF7")
            .then(data => {
                console.log("openOrgF7", data);
                setMateScheme(false)
                if (data?.existPosition ?? true) {
                    updateState("filtItems", {
                        ...filtItems,
                        orgs: data?.orgs ?? []
                    })
                } else {
                    // 清空岗位
                    updateState("filtItems", {
                        ...filtItems,
                        orgs: data?.orgs ?? [],
                        station: null
                    })
                }
            })
            .catch(err => {
                console.error("error");
            })
    }

    // 查询日期
    const changeSearchDate = (date, dateString) => {
        updateState("filtItems", {
            ...filtItems,
            queryDate: dateString
        })

        setMateScheme(false)
    }

    // 结构图方向
    const handleDir = value => {
        updateState("filtItems", {
            ...filtItems,
            orgchartdirection: value
        })

        setMateScheme(false)
    }

    // 显示层级
    const handleLevel = value => {
        updateState("filtItems", {
            ...filtItems,
            showLevel: parseInt(value)
        })

        setMateScheme(false)
    }

    // 汇报及协作关系
    const makeOpenTeamCooprelTypeF7 = () => {
        myInvoke("openTeamCooprelTypeF7", {}, "openTeamCooprelTypeF7")
            .then(data => {

                const _filtItems = {
                    ...filtItems,
                    showCooprelTypes: data.data
                }

                updateState("filtItems", _filtItems)
            })
    }


    useEffect(() => {
        console.log("new showScheme");

        setShowSchemeName(showScheme?.schemeName ?? "")

        setSchemeStatus(() => {
            return showScheme ? (showScheme.id === "NScheme" ? 1 : 2) : 3
        })

    }, [showScheme])

    return (
        <div className="station_filt-wrapper">
            <div className="filt-bar">
                <div className="plan">
                    <Select
                        className={"filt-select " + ((!mateScheme && (showScheme?.id ?? "") !== "NScheme") ? "not-curr" : "")}
                        borderType="bordered"
                        placeholder=""
                        style={{ width: "180px" }}
                        listHeight={184}
                        value={showScheme?.id ?? null}
                        onChange={handleSchmes}
                        visible={showSchemeBoard}
                        onSelect={() => { setShowSchemeBoard(false) }}
                        onVisibleChange={flag => { setShowSchemeBoard(flag) }}
                        dropdownRender={(menu) => (
                            <div>
                                {menu}
                                <div style={selectionStyle}>
                                    <Button type="ghost" className="compose-btn" onClick={handleAddScheme} disabled={schemeStatus === 3} style={{ width: "156px" }}>
                                        <Icon type="add" />新增方案
                                    </Button>
                                </div>
                            </div>
                        )}
                    >
                        {schemes.map((item) => {
                            return (
                                <Option key={item.id} value={item.id} size="small" item={item}>
                                    {item.schemeName}{item.default ? (
                                        <Tag type="attribute" color="end" style={selectTagStyle}  >
                                            默认
                                        </Tag>
                                    ) : ""}
                                </Option>
                            )
                        })}
                    </Select>
                </div>
                <Button type="text" className="i-collapse-board-btn" onClick={() => {
                    setShowFilt(!showFilt)
                }}>
                    {showFilt ? (<>收起过滤<Icon className="icon" type="arrow-up" /></>) : (<>展开过滤<Icon className="icon" type="arrow-down" /></>)}
                </Button>
            </div>
            <div className="filt-board" style={{ display: showFilt ? "" : "none" }}>
                {(schemeStatus !== 1) && (
                    <div className="scheme-edit">
                        <div className="form-group">
                            <div className="title required">方案名称</div>
                            <div className="info">
                                <Input
                                    value={showSchemeName}
                                    borderType="bordered"
                                    style={inputStyle}
                                    placeholder="请填写方案名称"
                                    onChange={e => { setShowSchemeName(e.target.value) }}
                                />
                            </div>
                        </div>
                        <div className="form-btn-group" style={{ paddingTop: "9px" }} >
                            <Button.Dropdown
                                className="i-drop-btn"
                                popperStyle={{ zIndex: 1000 }}
                                ghost
                                type="similar"
                                overlay={(() => {
                                    if (schemeStatus === 3) {
                                        return [
                                            { value: '3', label: '取消' },
                                        ]
                                    } else if (schemeStatus === 2) {
                                        if (showScheme?.default ?? false) {
                                            return [
                                                { value: '0', label: '取消默认' },
                                                { value: '2', label: '删除' },
                                            ]
                                        } else {
                                            return [
                                                { value: '1', label: '设为默认' },
                                                { value: '2', label: '删除' },
                                            ]
                                        }
                                    }
                                })()}
                                onClick={addScheme}
                                onItemClick={opScheme}>
                                保存
                            </Button.Dropdown>
                        </div>
                    </div>
                )}
                <div className="filt-list">
                    <div className="form-group" >
                        <div className="title required">
                            <span className="txt">主管责任单位</span>
                        </div>
                        <div className="info">
                            <Input
                                className="i-ellipsis-inp"
                                value={(() => {
                                    return ((filtItems.orgs.reduce((t1, t2) => t1 + ";" + t2.name, "")) + "").substring(1)
                                })()}
                                borderType="bordered"
                                style={inputStyle}
                                placeholder="请选择主管责任单位"
                                suffix={<Icon className="inp-icon" type="search" onClick={makeOpenOrgF7} />}
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="title required">
                            <span className="txt">查询日期</span>
                        </div>
                        <div className="info">
                            <DatePicker allowClear={false} inputReadOnly={true} disabledDate={(date) => {
                                return date && date > new Date()
                            }} borderType="bordered" style={inputStyle} value={new Date(filtItems.queryDate)} onChange={changeSearchDate} />
                        </div>
                    </div>
                    <div className="form-group" >
                        <div className="title required">
                            <span className="txt">查询岗位</span>
                        </div>
                        <div className="info">
                            <Input
                                value={filtItems?.station?.name ?? ""}
                                borderType="bordered"
                                style={inputStyle}
                                placeholder="请选择查询岗位"
                                suffix={<Icon className="inp-icon" type="search" onClick={makeOpenPositionF7} />}
                            />
                        </div>
                    </div>
                    <div className="form-group" >
                        <div className="title required">
                            <span className="txt">汇报及协作关系</span>
                        </div>
                        <div className="info">
                            <Input
                                value={filtItems?.showCooprelTypes?.name ?? ""}
                                borderType="bordered"
                                style={inputStyle}
                                placeholder="请选择汇报及协作关系"
                                suffix={<Icon className="inp-icon" type="search" onClick={makeOpenTeamCooprelTypeF7} />}
                            />
                        </div>
                    </div>
                    <div className="form-group" >
                        <div className="title required">
                            <span className="txt">结构图样式</span>
                        </div>
                        <div className="info">
                            <Input
                                value={filtItems?.chartStyle?.name ?? ""}
                                borderType="bordered"
                                style={inputStyle}
                                placeholder="请选择结构图样式"
                                suffix={<Icon className="inp-icon" type="search" onClick={makeOpenOrgChartStyleF7} />}
                            />
                        </div>
                    </div>
                    <div className="form-group" >
                        <div className="title required">
                            <span className="txt">结构图方向</span>
                        </div>
                        <div className="info">
                            <Select borderType="bordered" value={filtItems.orgchartdirection} onChange={handleDir} placeholder="选择方向" style={inputStyle}>
                                {chartdir.map(item => {
                                    return (
                                        <Option key={item.value} value={item.value}>{item.name}</Option>
                                    )
                                })}
                            </Select>
                        </div>
                    </div>
                    <div className="form-group" >
                        <div className="title required">
                            <span className="txt">显示层级</span>
                            <Tooltip placement="bottomLeft" tip="数据的层级小于显示层级时，将以实际数据的层级进行展示">
                                <Icon className="icon" type="tips" />
                            </Tooltip>
                        </div>
                        <div className="info">
                            <Select borderType="bordered" value={filtItems.showLevel} onChange={handleLevel} placeholder="选择层级" style={inputStyle} >
                                {new Array(Math.max(maxLevel, filtItems.showLevel)).fill("").map((item, index) => {
                                    return (
                                        <Option key={index + 1} value={index + 1}>{index + 1}</Option>
                                    )
                                })}
                            </Select>
                        </div>
                    </div>
                    <div className="form-btn-group" >
                        <Button type="primary" loading={searchLoading} onClick={submitFiltForm}>查询</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default APP